import { useCallback, useState } from 'react';
import { connect } from 'react-redux';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IKnmErknmFormJudgmentAgainstInfo } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormJudgmentAgainstInfo';
import { IDecisionForm } from 'DecisionPackage/MainModule/interfaces/IDecisionForm';

import { CommonCatalogsNamesEnum } from '../../../CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { IKnmJudgmentPunishmentIndexSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmJudgmentPunishmentIndexSelectOption';
import { IKnmJudgmentPunishmentTypeSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmJudgmentPunishmentTypeSelectOption';
import { getJudgmentPunishmentIndexSelectOptions } from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';
import { Row } from '../../../UIPackage/FormModule/components/Row';
import { SelectInputField } from '../../../UIPackage/MainModule/components/SelectInputField';
import { SelectInputFieldAutoOptions } from '../../../UIPackage/MainModule/components/SelectInputFieldAutoOptions';
import { TextInputField } from '../../../UIPackage/MainModule/components/TextInputField';

interface IDecisionJudgmentAgainstInfoProps {
  watchOnly: boolean;
  judgmentItemAgainstInfoName: string;
  judgmentItemAgainstValue: IKnmErknmFormJudgmentAgainstInfo | undefined;
  judgmentItemSubjectDataItemId: string;
  formRef: IDecisionFormRef | undefined;
}

interface IDecisionJudgmentAgainstInfoStoreProps {
  judgmentPunishmentIndexSelectOptions: IKnmJudgmentPunishmentIndexSelectOption[] | undefined;
}

const DecisionJudgmentAgainstInfoWithoutStore = ({
  watchOnly,
  formRef,
  judgmentItemAgainstInfoName,
  judgmentItemAgainstValue,
  judgmentPunishmentIndexSelectOptions,
  judgmentItemSubjectDataItemId,
}: IDecisionJudgmentAgainstInfoProps & IDecisionJudgmentAgainstInfoStoreProps) => {
  const [filteredPunishmentIndexSelectOptions, setFilteredPunishmentIndexSelectOptions] = useState<
    IKnmJudgmentPunishmentIndexSelectOption[] | undefined
  >(undefined);
  const handlePunishmentTypeChange = useCallback(
    (v: IKnmJudgmentPunishmentTypeSelectOption) => {
      formRef?.current.change(`${judgmentItemAgainstInfoName}.amountOfPunishment` as keyof IDecisionForm);
      formRef?.current.change(`${judgmentItemAgainstInfoName}.punishmentIndex` as keyof IDecisionForm);
      formRef?.current.change(`${judgmentItemAgainstInfoName}.punishmentNoteLawsuits` as keyof IDecisionForm);

      const indexOptions = judgmentPunishmentIndexSelectOptions?.filter(x => x.punishmentTypeIds.includes(v.id));

      setFilteredPunishmentIndexSelectOptions(indexOptions);

      if (indexOptions?.length === 1) {
        formRef?.current.change(
          `${judgmentItemAgainstInfoName}.punishmentIndex` as keyof IDecisionForm,
          // @ts-ignore
          indexOptions[0],
        );
      }
    },
    [formRef, judgmentItemAgainstInfoName, judgmentPunishmentIndexSelectOptions],
  );

  return (
    <>
      <Row>
        <FieldBlock id={`${judgmentItemSubjectDataItemId}.prosecutionType`} size="half">
          <SelectInputFieldAutoOptions
            name={`${judgmentItemAgainstInfoName}.prosecutionType`}
            isClearable={true}
            optionName={CommonCatalogsNamesEnum.JUDGMENT_PROSECUTION_TYPES}
            placeholder="Выберите вид ответственности"
            disabled={watchOnly}
          />
        </FieldBlock>
        <FieldBlock id={`${judgmentItemSubjectDataItemId}.punishmentType`} size="half">
          <SelectInputFieldAutoOptions
            name={`${judgmentItemAgainstInfoName}.punishmentType`}
            isClearable={true}
            optionName={CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_TYPES}
            placeholder="Выберите вид наказания"
            disabled={watchOnly}
            onChange={handlePunishmentTypeChange}
          />
        </FieldBlock>
      </Row>
      {judgmentItemAgainstValue?.punishmentType?.hasIndexAndAmount && (
        <Row>
          <FieldBlock id={`${judgmentItemSubjectDataItemId}.amountOfPunishment`} size="half">
            <TextInputField
              name={`${judgmentItemAgainstInfoName}.amountOfPunishment`}
              disabled={watchOnly}
              placeholder="Введите размер наказания"
              type="number"
              min={0}
            />
          </FieldBlock>
          <FieldBlock id={`${judgmentItemSubjectDataItemId}.punishmentIndex`} size="half">
            <SelectInputField
              name={`${judgmentItemAgainstInfoName}.punishmentIndex`}
              placeholder="Выберите показатель"
              isClearable={false}
              options={filteredPunishmentIndexSelectOptions}
              disabled={watchOnly}
            />
          </FieldBlock>
        </Row>
      )}
      {judgmentItemAgainstValue?.punishmentType?.hasText && (
        <Row>
          <FieldBlock id={`${judgmentItemSubjectDataItemId}.punishmentNoteLawsuits`}>
            <TextInputField
              name={`${judgmentItemAgainstInfoName}.punishmentNoteLawsuits`}
              disabled={watchOnly}
              placeholder="Дополнительная информация (заполняется при необходимости)"
            />
          </FieldBlock>
        </Row>
      )}
    </>
  );
};

const mapStateToProps = (state: IRootState): IDecisionJudgmentAgainstInfoStoreProps => ({
  judgmentPunishmentIndexSelectOptions: getJudgmentPunishmentIndexSelectOptions(state),
});

export const DecisionJudgmentAgainstInfo = connect(mapStateToProps)(DecisionJudgmentAgainstInfoWithoutStore);
